import {useSuspenseQuery} from "@tanstack/react-query";
import {useMemo} from "react";
import {secretApi} from "../../../api/api";
import {getRegion} from "../../../function";
import sll_tournament, {sll_tournament2, sll_tournament3} from "../../api/sll_tournament";

export const useSliApi = ({tournamentName}) => {
    const query = useSuspenseQuery(
        {
            queryKey: ['sliApi',tournamentName],
            queryFn: async () => {
                if(!tournamentName) {
                    throw new Error("no tournamentName")
                }
                const best = await best_api({tournamentName})
                const all_teams = await all_teams_api({tournamentName})
                let tournament;
                if(tournamentName === 'gsg' || tournamentName === 'mgh2') {
                    tournament = await sll_tournament3({tournamentName})
                } else if(tournamentName === 'sll2') {
                    tournament = await sll_tournament2({tournamentName})
                } else {
                    tournament = await sll_tournament({tournamentName})
                }
                return {best, all_teams, tournament}
            },
            staleTime: Infinity,
        })


    const list = useMemo(() => {
        if (!query?.data) {
            return {best: {}, all_teams: {}, tournament: {A: [], B: [], FINALS: []}}
        }
        return query.data
    }, [query.data])

    return {query, list};
}


const getMatchDataAPI = (action) => {
    const changeRegion = getRegion(action.region);
    const url = `${process.env.REACT_APP_CACHE_API}match/match-cached?match_id=${action.matchId}&platform_id=${changeRegion}`
    return secretApi.get(url).then((res) => res.data);
}

const best_api = async ({tournamentName}) => {
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        url.searchParams.set('tournament',tournamentName)
        const result = await secretApi.get(url.toString());
        const best = result.data.first_ai_score.best;
        const data = result.data.first_ai_score

        const topMatchId = data?.TOP?.match_id
        const jungleMatchId = data?.JUNGLE?.match_id
        const middleMatchId = data?.MIDDLE?.match_id
        const botMatchId = data?.BOTTOM?.match_id
        const supMatchId = data?.UTILITY?.match_id
        const bestMatchId = data?.best?.match_id


        const matchIds = [topMatchId, jungleMatchId, middleMatchId, botMatchId, supMatchId, bestMatchId]

        const matches = await Promise.all(matchIds.map((data) => {
            if(!data) {
                return {}
            }
            return getMatchDataAPI({matchId: data, platform_id: 'KR'})
        }))

        if(topMatchId) {
            result.data.first_ai_score.TOP.match = matches[0]
        }

        if(jungleMatchId) {
            result.data.first_ai_score.JUNGLE.match = matches[1]
        }
        if(middleMatchId) {
            result.data.first_ai_score.MIDDLE.match = matches[2]
        }
        if(botMatchId) {
            result.data.first_ai_score.BOTTOM.match = matches[3]
        }
        if(supMatchId) {
            result.data.first_ai_score.UTILITY.match = matches[4]
        }
        if(bestMatchId) {
            result.data.first_ai_score.best.match = matches[5]
        }


        return result?.data?.first_ai_score;
    } catch (e) {
        console.log(e)
        return {};
    }
}


const all_teams_api = async ({tournamentName}) => {
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_all_team`);
        url.searchParams.set('tournament',tournamentName)
        const result = await secretApi.get(url.toString());
        const array = Object.entries(result.data.all_team_data).reduce((sum, cur) => {
            cur[1].team_name = cur[0];
            const playerList = Object.values(cur[1]).reduce((sum, cur) => {
                if (typeof cur === 'object') {
                    sum.push(cur)
                }
                return sum
            }, [])
            cur[1].players = playerList;
            sum.push(cur[1])
            return sum
        }, []);
        return array
    } catch (e) {
        return []
    }
}

